import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, Box} from "@mui/material";
import {formatCurrency, formatNumber, formatPercent} from "../utils/formatters";
import {ChartPicker} from "./filters/ChartPicker";

const formatValue = (value, valueType) => {
    if (value === null || value === undefined) {
        return 'N/A';
    }
    if (valueType === 'percent') {
        return formatPercent(value);
    }
    if (valueType === 'count') {
        return formatNumber(value);
    }
    return formatCurrency(value);
};

const formatTotalImpact = (change, valueType) => {
    if (!change || change === 0) {
        return <Typography component="span">-</Typography>;
    }

    const formatted = formatValue(Math.abs(change), valueType);
    if (change > 0) {
        return (
            <Typography component="span" style={{color: '#4CAF50', fontWeight: 'bold'}}>
                +{formatted}
            </Typography>
        );
    }

    return (
        <Typography component="span" style={{color: '#F44336', fontWeight: 'bold'}}>
            -{formatted}
        </Typography>
    );
};

export const KpiSummaryTable = ({
    kpi,
    summary,
    calcConfigs,
    onKpiChange
}) => {
    const theme = useTheme();
    const calcTypes = Object.keys(calcConfigs || {});

    if (!kpi || !summary || calcTypes.length === 0) {
        return (
            <Paper style={{...theme.palette.contentPanel, padding: 20}}>
                <Typography variant="h6">Summary</Typography>
                <Typography variant="body2" color="textSecondary" style={{marginTop: 20}}>
                    No KPI data available
                </Typography>
            </Paper>
        );
    }

    return (
        <Paper style={{...theme.palette.contentPanel, padding: 20, height: 'fit-content'}}>
            <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                {onKpiChange && kpi ? (
                    <ChartPicker chartTypeSetter={onKpiChange} currentValue={kpi.value}/>
                ) : (
                    <Typography variant="h6" color="primary">
                        {kpi?.name}
                    </Typography>
                )}
            </Box>

            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{fontWeight: 'bold', color: theme.palette.primary.main}}>
                                Component
                            </TableCell>
                            <TableCell align="center" style={{color: theme.palette.primary.main, fontWeight: 'bold'}}>
                                Current
                            </TableCell>
                            <TableCell align="center" style={{color: theme.palette.primary.main, fontWeight: 'bold'}}>
                                Prior
                            </TableCell>
                            <TableCell align="center" style={{color: theme.palette.primary.main, fontWeight: 'bold'}}>
                                Total Impact
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {calcTypes.map((calcType) => {
                            const config = calcConfigs[calcType] || {};
                            const values = summary[calcType] || {};
                            const valueType = config.valueType;

                            return (
                                <TableRow key={calcType}>
                                    <TableCell style={{fontWeight: 'bold', color: theme.palette.primary.main}}>
                                        {config.name || calcType}
                                    </TableCell>
                                    <TableCell align="center">
                                        <strong>{formatValue(values.current, valueType)}</strong>
                                    </TableCell>
                                    <TableCell align="center" style={{color: '#666'}}>
                                        {formatValue(values.prior, valueType)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {formatTotalImpact(values.change, valueType)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};
